export default __webpack_public_path__ + "static/1274-d813149f9e9ad07d400217923326cbc2.png";